import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
  data?: any;
};

export const demoToolsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDemoToolsConfig: builder.query<
      CommonResponseType & { data: { enabled: boolean } },
      void
    >({
      query: () => ({
        url: END_POINTS.demoToolsConfig,
        method: "GET",
      }),
    }),

    demoPropertyAction: builder.mutation<
      CommonResponseType,
      { id: string; encryptedBody: CommonBody }
    >({
      query: ({ id, encryptedBody }) => ({
        url: `${END_POINTS.demoToolsProperty}/${id}`,
        method: "POST",
        body: encryptedBody,
      }),
    }),

    demoUserAction: builder.mutation<
      CommonResponseType,
      { id: string; encryptedBody: CommonBody }
    >({
      query: ({ id, encryptedBody }) => ({
        url: `${END_POINTS.demoToolsUser}/${id}`,
        method: "POST",
        body: encryptedBody,
      }),
    }),

    demoRefundAction: builder.mutation<
      CommonResponseType,
      { id: string; encryptedBody: CommonBody }
    >({
      query: ({ id, encryptedBody }) => ({
        url: `${END_POINTS.demoToolsRefund}/${id}`,
        method: "POST",
        body: encryptedBody,
      }),
    }),
  }),
});

export const {
  useLazyGetDemoToolsConfigQuery,
  useDemoPropertyActionMutation,
  useDemoUserActionMutation,
  useDemoRefundActionMutation,
} = demoToolsApi;
